/* eslint-disable global-require */
import React, { Component } from 'react';
import { Button, Form } from 'antd';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import { isEmpty } from 'lodash';
import { setToken, getUserInfo } from 'src/appRedux/actions/Auth';
import IntlMessages from 'util/IntlMessages';
import InfoView from 'components/InfoView';
import config from 'util/config';
import { setCookieValue } from 'src/util/Common';
import { listVaiTro, convertVaiTroUserToListAsCamel, extractToRedirect } from 'src/helpers/Authorization';
import PropTypes from 'prop-types';
import Particles from 'react-particles-js';

let isMounted = true;

/**
 * Set isMounted
 * @param {boolean} value
 */
const setIsMounted = (value = true) => {
  isMounted = value;
  return isMounted;
};

/**
 * Get isMounted
 */
const getIsMounted = () => isMounted;

const FormItem = Form.Item;

const particlesOptions = {
  particles: {
    number: {
      value: 40,
      density: {
        enable: true,
        value_area: 800
      }
    },
    size: {
      value: 1
    }
  },
  interactivity: {
    events: {
      onhover: {
        enable: true,
        mode: 'repulse'
      }
    }
  }
};

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      redirect: false
    };
    setIsMounted(true);
  }

  async componentDidMount() {
    const { location, setToken, getUserInfo } = this.props;
    const query = await QueryString.parse(location.search);
    if (query.token) {
      await setCookieValue('accessTokenBDT', query.token);
      await setToken(query.token);
      await getUserInfo();
      this.setStateData({ token: query.token });
    }
    if (location.state && location.state.from.pathname.includes('Forbidden')) {
      this.props.history.push('/Forbidden');
    }
  }

  async componentDidUpdate() {
    const { token, redirect } = this.state;
    const { auth } = this.props;
    if (token && auth && !isEmpty(auth.authUser) && !redirect) {
      // Xử lý dữ liệu để reditect
      const vaiTro = listVaiTro(auth.authUser);
      const listVaiTroArr = convertVaiTroUserToListAsCamel(vaiTro);
      const urlToRedirect = extractToRedirect(listVaiTroArr);
      await setCookieValue('defaultUrl', urlToRedirect);
      await this.setStateData({ redirect: true }, () => {
        setTimeout(() => this.props.history.push({
          pathname: '/danh-muc/nhap-lieu'
        }), 1000);
      });
    }
  }

  componentWillUnmount() {
    setIsMounted(false);
  }

  /**
   * Set state properties
   * @param {object} state data cần setState
   * @param {function} callback thực thi hàm sau khi đã cập nhật state hoàn tất
   * @returns {void} gọi hàm this.setStateData để cập nhật state
   * @memberof SignIn
   */
  setStateData = (state, callback) => {
    if (!getIsMounted()) {
      return;
    }
    this.setState(state, callback);
  }

  /**
   * Chuyển sang trang đăng nhập tập trung
   * @param {Object} e
   * @memberof SignIn
   */
  handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = `${config.API_URL}/secure/token?redirectTo=${window.location.href}`;
  };

  render() {
    const { token } = this.state;
    return (
      <div className="gx-app-login-wrap">
        <Particles className="particles" params={particlesOptions} />
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                {/* <img src={require("assets/images/logoQN.png")} alt='Quang Nam Provider' /> */}
              </div>
              <div className="gx-app-logo-wid">
                {/* <h1><IntlMessages id="app.userAuth.signIn" /></h1>
                <p><IntlMessages id="app.userAuth.bySigning" /></p>
                <p><IntlMessages id="app.userAuth.getAccount" /></p> */}
              </div>
              <div className="gx-app-logo">
                {/* <img alt="example" src={require('assets/images/logoQTIdata.png')} /> */}
              </div>
            </div>
            <div className="gx-app-login-content text-center p25">
              <div className="gx-app-logo">
                <img alt="example" src={require('assets/images/iconQTI.svg')} width="70px" />
              </div>
              <h3 className="text-uppercase color-red my20">
                HỆ THỐNG CƠ SỞ DỮ LIỆU <br />
                CHUYÊN NGÀNH DÂN TỘC
              </h3>
              <Form className="gx-signin-form gx-form-row0" onSubmit={this.handleSubmit}>
                <FormItem className="gx-mb-0">
                  {!token
                    ? (
                      <Button className="gx-mb-0" htmlType="submit" icon="login" shape="round" type="primary">
                        <IntlMessages id="app.userAuth.signIn" />
                      </Button>
                    )
                    : <Button>Đang chuyển trang</Button>}
                </FormItem>
              </Form>
            </div>
            <InfoView />

          </div>
          <p className="gx-text-light gx-fs-sm text-center m10">Phát triển bởi Trung Tâm CNTT & TT Quảng Nam (QTI).</p>
        </div>
      </div>
    );
  }
}

SignIn.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  auth: PropTypes.objectOf(PropTypes.any).isRequired,
  setToken: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired
};

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps, { setToken, getUserInfo })(WrappedNormalLoginForm);
